import Progress from 'easy-circular-progress';
import { Inject } from 'vue-di-container';
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import LoaderService from '../../Services/LoaderService';
import { Toaster } from '../../Services/toast';
import UserModel from '../../shared/userService/Model/UserModel';
import UserRoleService from '../../shared/userService/UserRoleService';
import UserService from '../../shared/userService/UserService';
import { canProcessComplaints as resolveCanProcessComplaints, parseAllowedScreensFromPermissionsResponse } from '../../shared/screenPermissionHelper';
import PermissionManagementService from '../UserManagement/PermissionManagement/PermissionManagementService';
import { FilterModel } from './FilterModel';
import WithRender from './SenderComplaints.html';
import { SenderComplaintsModel,DropdownModel } from './SenderComplaintsModel';
import SenderComplaintsService from './SenderComplaintsService';


@WithRender
@Component({
    components: {
        Progress,
    },
    diProvide: [
        SenderComplaintsService,
        UserService,
        UserRoleService,
        PermissionManagementService,
    ],
})
export default class SenderComplaints extends Vue {
    @Inject(UserService) public userService!: UserService;
    @Inject(SenderComplaintsService) public senderComplaintsService!: SenderComplaintsService;
    @Inject(LoaderService) public loaderService!: LoaderService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;
    @Inject(PermissionManagementService) public permissionManagementService!: PermissionManagementService;
    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;
    public requestStatus: string = '';
    public senderStatus: string = '';
    public reactivateids: string[] = [];
    public complaintId: string = '';
    public senders: SenderComplaintsModel[] = [];
    public selected: SenderComplaintsModel[] = [];
    public senderStatusModel: any = {
        senderName: '',
        clientName: '',
        crNumber: '',
        enterpriseUnifiedNumber: '',
        senderType: '',
        senderStatus: '',
        hrsdLicense: '',
        isAlreadyExist: '',
    };
    public reactivateDialog: boolean = false;
    public closeComplaintDialog: boolean = false;
    public deactivateComplaintDialog: boolean = false;
    public filterModel: FilterModel = {
        complaintId: '',
        senderName: '',
        clientName: '',
        providerName: '',
        complaintStatus: 0,
        dateFrom: '',
        dateTo: '',
    };
    public createdDateFromMenu: boolean = false;
    public createdDateToMenu: boolean = false;
 
 public complaintStatusList: DropdownModel[] = [
        {
            id: 1,
           
            name:  this.$t('senderComplaints.pendingForReview').toString(),
        },
        {
            id: 2,
            name: this.$t('senderComplaints.deactivated').toString(),
        },
        {
            id: 3,
            name: this.$t('senderComplaints.falseComplaint').toString(),
        },
        {
            id: 4,
            name: this.$t('senderComplaints.reactivated').toString(),
        },
    ];
    public statusOptions: any[] = [
        {
            id: '1',
            name: this.$t('senderComplaints.pendingFor').toString()
                + ' ' + this.$t('senderComplaints.approval').toString(),
        },
        {
            id: '2',
            name: this.$t('senderComplaints.pendingFor').toString()
                + ' ' + this.$t('senderComplaints.payment').toString(),
        },
        {
            id: '3',
            name: this.$t('senderComplaints.rejected').toString()
                + ' ' + this.$t('senderComplaints.requests').toString(),
        },
        {
            id: '4',
            name: this.$t('senderComplaints.inactive').toString()
                + ' ' + this.$t('senderComplaints.requests').toString(),
        },
        {
            id: '5',
            name: this.$t('senderComplaints.active').toString()
                + ' ' + this.$t('senderComplaints.requests').toString(),
        },
        {
            id: '7',
            name: this.$t('senderComplaints.partially').toString()
                + ' ' + this.$t('senderComplaints.activated').toString(),
        },
    ];
    public user: UserModel = {
        userId: '',
        username: '',
        details: {
            Email: '',
            MobilePhone: '',
            Operator: '',
            Provider: '',
            OperatorId: '',
            ProviderId: '',
            TenantId: '',
            Role: '',
            ChangePasswordRequired: '',
        },
    };
    public senderName: string = '';
    public autoInterval: any;
    public userRole: number = 0;
    public canProcessComplaints: boolean = false;
    public allowedScreens: Set<string> | null = null;
    public scrollDiv: any;
    public nextPage: string = '';
    public scrollTop: number = 0;
    public selectedIds: string[] = [];
    public ids: string[] = [];
    public sendersCount: number = 0;
    public User: any;
    public anySelected: boolean = false;
    public pagination: any = {};
    public tenantId: string = '';
    public senderType: number[] = [];
    public headers: any = [
        { text: this.$t('senderComplaints.complaintId'), sortable: false, value: 'complaintId', align: 'center' },
        { text: this.$t('senderComplaints.senderName'), sortable: false, value: 'senderName', align: 'center' },
        { text: this.$t('senderComplaints.clientName'), sortable: false, value: 'clientName', align: 'center' },
        { text: this.$t('senderComplaints.providerName'), sortable: false, value: 'providerName', align: 'center' },
        {
            text: this.$t('senderComplaints.requestDate'), sortable: false,
            value: 'createdDate', align: 'center',
        },
        {
            text: this.$t('senderComplaints.complaintStatus'), sortable: false, value: 'complaintStatus',
            align: 'center', width: '190',
        },
        {
            text: this.$t('senderComplaints.status'), sortable: false, value: 'requestStatus',
            align: 'center', width: '190',
        },

        { text: this.$t('shared.actions'), sortable: false, align: 'center', width: '145' },
    ];
    public checkColor(typeStatus: string) {
        typeStatus = typeStatus.toString();
        switch (typeStatus) {
            case '1': {
                return '#c427ba';
            }
            case '2': {
                return '#5aaa0b';
            }
            case '3': {
                return '#C42727';
            }
            case '4': {
                return '#aaa7a7';
            }
            case '5': {
                return '#014bb1';
            }
            case '7': {
                return '#5c9bf2';
            }
            default: {
                return '#F78500';
            }
        }
    }
    public getComplaintStatus(typeStatus: number) {
        switch (typeStatus) {
             case 0: {
                 return this.$t('shared.complaintStatus') 
            }
            case 1: {
                return this.$t('senderComplaints.pendingForReview').toString();
            }
            case 2: {
                return this.$t('senderComplaints.deactivated').toString();
            }
            case 3: {
                return this.$t('senderComplaints.falseComplaint').toString();
            }
            case 4: {
                return this.$t('senderComplaints.reactivated').toString();
            }
        }
    }
    public GetSenderStatus(typeStatus: string) {
        typeStatus = typeStatus.toString();
        switch (typeStatus) {
            case '1': {
                return 'Pending Approval';
            }
            case '2': {
                return 'Approved';
            }
            case '3': {
                return 'Rejected';
            }
            case '4': {
                return 'Deactivated';
            }
            case '5': {
                return 'Expired';
            }
            case '6': {
                return 'Deleted';
            }
            case '7': {
                return 'Paid';
            }
            default: {
                return '';
            }
        }
    }




    public async mounted() {
        this.$emit('childinit', this.layoutSup);
        this.User = await this.userService.getUser();
        this.userRole = this.userRoleService.GetUserRole(this.User);
        this.tenantId = this.User.details.TenantId;
        await this.loadProcessingPermission();
        this.search();
    }

    private async loadProcessingPermission(): Promise<void> {
        if (this.userRole === 4) {
            const res = await this.permissionManagementService.GetPermissions(this.User.userId);
            this.allowedScreens = parseAllowedScreensFromPermissionsResponse(res);
        }
        this.canProcessComplaints = resolveCanProcessComplaints(this.userRole, this.allowedScreens);
    }

    public async reset() {
        this.filterModel.senderName = '';
        this.filterModel.complaintId = '';
        this.filterModel.clientName = '';
        this.filterModel.providerName = '';
        this.filterModel.complaintStatus = 0;
        this.filterModel.dateFrom = '';
        this.filterModel.dateTo = '';
        this.createdDateFromMenu = false;
        this.createdDateToMenu = false;

        await this.search();
    }

    public get isDateRangeInvalid(): boolean {
        const from = this.filterModel.dateFrom;
        const to = this.filterModel.dateTo;
        if (!from || !to) {
            return false;
        }
        return from > to;
    }

    private canApplyFilters(): boolean {
        if (this.isDateRangeInvalid) {
            Toaster.error(this.$t('shared.invalidDateRange').toString());
            return false;
        }
        return true;
    }

    public onDateChange(field: 'from' | 'to') {
        if (field === 'from') {
            this.createdDateFromMenu = false;
        }
        if (field === 'to') {
            this.createdDateToMenu = false;
        }
        this.search();
    }

    public async search() {
        if (!this.canApplyFilters()) {
            return;
        }
        this.pagination = { ...this.pagination, page: 1, rowsPerPage: this.getPageSize() };

        const model = this.buildGetModel(0, this.getPageSize());
        const response = await this.senderComplaintsService.Get(model);
        if (response !== false) {
            if (!response.isSuccess) {
                Toaster.error(response.errorMessage);
                return;
            }
        }
        this.senders = response.result;
        this.sendersCount = response.totalCount;
    }

    public async exportToExcel() {
        if (!this.canApplyFilters()) {
            return;
        }
        const response = await this.senderComplaintsService.ExportSenderComplaintReport(this.filterModel);
        if (response === false) {
            Toaster.error('Export failed');
            return;
        }
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
    }

    public isEqual(value1: string | null, value2: string) {
        return (value1 === '' || value1 === null || value2.includes(value1));
    }
    public Details(id: string) {
        this.$router.push({ name: 'ComplaintDetails', params: { id } });
    }
    public async filter(requestStatus: string, senderStatus: string) {
        if (!this.canApplyFilters()) {
            return;
        }
        if (this.requestStatus === requestStatus &&
            this.senderStatus === senderStatus) {
            this.requestStatus = '0';
            this.senderStatus = '0';
            requestStatus = '0';
            senderStatus = '0';
        } else {
            this.requestStatus = requestStatus;
            this.senderStatus = senderStatus;
        }
        const model = this.buildGetModel(0, this.getPageSize());
        const response = await this.senderComplaintsService.Get(model);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.senders = response.result;
        this.sendersCount = response.totalCount;
    }

    public selectAll() {
        if (this.selected.length) {
            this.selected = [];
            this.selectedIds = [];
        } else {
            this.selected = this.senders.slice();
            this.selectedIds = this.senders.map((x) => x.complaintId);
        }
    }

    public select(event: any, id: string) {
        if (!event) {
            const index = this.selectedIds.indexOf(id);
            this.selectedIds.splice(index, 1);
        } else {
            this.selectedIds.push(id);
        }
    }
    public showReactivateDialog(id: string) {
        this.reactivateids = [];
        if (id !== '') {
            this.reactivateids.push(id);
        } else {
            this.reactivateids = this.selectedIds;
        }
        this.reactivateDialog = true;
    }
    public showCloseComplaintDialog(id: string) {
        this.complaintId = id;
        this.closeComplaintDialog = true;
    }
    public hideReactivateDialog() {
        this.reactivateDialog = false;
    }
    public showDeactivateComplaintDialog(id: string) {
        this.complaintId = id;
        this.deactivateComplaintDialog = true;
    }
    public hideDeactivateComplaintDialog() {
        this.deactivateComplaintDialog = false;
    }
    public hideCloseComplaintDialog() {
        this.closeComplaintDialog = false;
    }
    public async Reactivate(id: string) {
        let ids: string[] = [];
        ids = this.reactivateids;
        if (this.senders.filter((s) => ids.includes(s.senderRequestId) && s.senderStatus.toString() !== '4').length > 0) {
            Toaster.error(this.$t('senderComplaints.notAllSenderAreDeactivated').toString());
            this.reactivateDialog = false;
            return;
        }
        const response = await this.senderComplaintsService.Reactivate(ids);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
            this.reactivateDialog = false;
            await this.reload();
        } else {
            this.reactivateDialog = false;
            this.selectedIds = [];
            Toaster.success(this.$t('senderComplaints.reactivatedsuccessfully').toString());
            await this.reload();
        }
    }
    
    public async closeComplaint() {
        const response = await this.senderComplaintsService.closeComplaint(this.complaintId);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        } else {
            Toaster.success(this.$t('senderComplaints.complaintClosedSuccessfully').toString());
        }
        await this.reload();
        this.closeComplaintDialog = false;
    }
    public async deactivateComplaint() {
        const response = await this.senderComplaintsService.deactivateComplaint(this.complaintId);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        } else {
            Toaster.success(this.$t('senderComplaints.complaintDeactivatedsuccessfully').toString());
        }
        await this.reload();
        this.deactivateComplaintDialog = false;
    }

    public async updatePaginate(val: any) {
        if (!val || typeof val.page !== 'number') return;
        if (!this.canApplyFilters()) {
            return;
        }

        const model = this.buildGetModel(val.page - 1, val.rowsPerPage);
        const response = await this.senderComplaintsService.Get(model);
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
            return;
        }
        this.senders = response.result;
        this.sendersCount = response.totalCount;
    }
    public get isAnySelected(): boolean {
        this.anySelected = this.selectedIds.length > 0;
        return this.anySelected;
    }
    public async reload() {
        this.pagination = { ...this.pagination, page: 1, rowsPerPage: this.getPageSize() };

        const model = this.buildGetModel(0, this.getPageSize());
        const response = await this.senderComplaintsService.Get(model);
        this.senders = response.result;
        this.sendersCount = response.totalCount;
        this.selectedIds = [];
        this.selected = [];
    }

    private getPageSize(): number {
        return (this.pagination && this.pagination.rowsPerPage) ? this.pagination.rowsPerPage : 10;
    }

    private buildGetModel(pageIndex: number, pageSize: number) {
        return {
            senderName: this.filterModel.senderName || '',
            complaintId: this.filterModel.complaintId || '',
            clientName: this.filterModel.clientName || '',
            providerName: this.filterModel.providerName || '',
            complaintStatus: this.filterModel.complaintStatus || 0,
            dateFrom: this.filterModel.dateFrom || '',
            dateTo: this.filterModel.dateTo || '',
            pageIndex: pageIndex.toString(),
            pagesize: pageSize.toString(),
        };
    }

}